export default __webpack_public_path__ + "static/lumin-e264a944c89cbf70b3b749a243ff8fc9.webm";